import { render, staticRenderFns } from "./SpplierInfoBase.vue?vue&type=template&id=b1f6d82c&scoped=true&"
import script from "./SpplierInfoBase.vue?vue&type=script&lang=js&"
export * from "./SpplierInfoBase.vue?vue&type=script&lang=js&"
import style0 from "./SpplierInfoBase.vue?vue&type=style&index=0&id=b1f6d82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f6d82c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
